'use client';

import React, {
  useMemo,
} from 'react';
import Link from 'next/link';
import ProfileDropdown from '@/components/ProfileDropdown';
import {
  useGetOrgMultimediaByType,
} from '@/hooks/useApi';
import {
  useAuth,
} from '@/contexts/AuthContext';
import head from 'lodash/head';
import clsx from 'clsx';

type AppHeaderProps = {
  classes?: {
    root?: string;
    header?: string;
  };
};

export default function AppHeader({  classes }: AppHeaderProps) {
  const { isAuthenticated, user } = useAuth();
  const { data: orgMultimedia } = useGetOrgMultimediaByType(user?.organization?.organizationId ?? 0, 'BannerPicture', isAuthenticated);
  const url = useMemo(
    () => head(orgMultimedia?.list)?.url?.value ?? null,
    [orgMultimedia],
  );
  return (
    <header className={clsx('sticky top-0 z-10 bg-white border-b border-gray-200', classes?.header)}>
      <div className={clsx('container-width px-4 py-4', classes?.root)}>
        <div className="flex items-center justify-between !min-w-14 h-14">
          <div className="flex items-center gap-3">
            <div className="h-14 flex items-center">
              {url && (
                <Link href="/" className="block h-14 w-auto">
                  <img src={url} alt={user?.organization?.name ?? ''} className="h-14 w-auto" />
                </Link>
              )}
            </div>
          </div>
          <div className="flex items-center">
            <ProfileDropdown />
          </div>
        </div>
      </div>
    </header>
  );
}
